import type { Directive } from "vue";

export const vMuted: Directive<HTMLVideoElement> = {
	mounted(el) {
		el.muted = true;
		el.setAttribute("muted", "");
	},
};
